import { cn } from '@/lib/utils';

interface AmbientGlowProps {
  /** Position classes, e.g. 'top-0 left-0 -translate-x-1/2 -translate-y-1/2' */
  position?: string;
  color?: 'primary' | 'accent' | 'amber';
  size?: number;
  className?: string;
}

const colorMap = {
  primary: 'bg-primary/25',
  accent: 'bg-accent/25',
  amber: 'bg-[hsl(var(--amber))]/20',
};

/** Soft blurred color blob used behind GlassCards / section headers for ambient depth, no images needed. */
export function AmbientGlow({
  position = 'top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2',
  color = 'primary',
  size = 480,
  className,
}: AmbientGlowProps) {
  return (
    <div
      className={cn('pointer-events-none absolute rounded-full blur-3xl', position, colorMap[color], className)}
      style={{ width: size, height: size }}
      aria-hidden='true'
    />
  );
}

export default AmbientGlow;
